import React from 'react';
import logo from './cb_ny_logo_temp.svg';
import './App.css';
import DecryptedText from './DecryptedText';

function App() {
  return (
    <div className="App">
      {/* Centered placeholder */}
      <div className="placeholder-message">
        <DecryptedText
          text="Site is being updated, come back soon :)"
          animateOn="view"          // start when it scrolls into view
          sequential={true}         // reveal one character at a time, in order
          revealDirection="start"   // left-to-right
          speed={100}               // ms between each scramble step (↑ slower → bigger)
          maxIterations={20}        // how many intermediate scrambles before locking in
          encryptedClassName="encrypted"  // class for the “scrambled” letters
          className="revealed"            // class for the final letter
          parentClassName="decrypted-wrapper"
        />
      </div>

      {/* Tiny top-right logo */}
      <img src={logo} className="App-logo" alt="Cerebionics logo" />
    </div>
  );
}

export default App;
